/*
 * Module for the Seminar Cancellation Letters job criteria page
 */
rs.module("content/jobs/criteria/seminarcancellationletters",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the page
        function initialize(jsSelectors, availablePrinters, preferredPrinter) {

            var criteria = $.js(jsSelectors.criteria);

            var skipReviewCheckBox = criteria.js(jsSelectors.skipReviewCheckBox);
            var printersSelect = criteria.js(jsSelectors.printersSelect);

            // Get Select Helper for printersSelect since we're updating its options and properties
            var printersSelectHelper = selectHelper.getHelper(printersSelect);

            // disable the printers dropdown based on the skip Review check box
            skipReviewCheckBox.change(function () {
                enableDisableFields();
            });

            // Enable or disable fields
            function enableDisableFields() {

                if (skipReviewCheckBox.is(":checked")) {
                    printersSelectHelper.setDisabled(false);
                    printersSelectHelper.replaceOptions(availablePrinters);

                    // Since we have reloaded options, we should again default to the user's preferred Printer
                    if (preferredPrinter != '') {
                        printersSelectHelper.setValue(preferredPrinter);
                    }
                }
                else {
                    printersSelectHelper.clearOptions();
                    printersSelectHelper.setDisabled(true);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);